import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getConsent, setConsent, trackPageview, initGA4 } from '@/lib/analytics';

const PrivacyBanner = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
    if (value === 'all') {
      trackPageview(location.pathname);
      initGA4();
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0A2463] border-t border-white/10 p-4 sm:p-5 shadow-2xl" data-testid="privacy-banner">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <p className="text-white/80 text-xs sm:text-sm font-body flex-1 text-center sm:text-left">
          Utilizamos cookies essenciais e, com sua permissão, cookies de análise para entender como o site é usado e melhorar sua experiência. Saiba mais na nossa{' '}
          <Link to="/privacidade" className="text-[#00A8E8] underline">Política de Privacidade</Link>.
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button onClick={() => choose('essential')} data-testid="reject-cookies"
            className="bg-white/10 hover:bg-white/20 text-white/80 px-4 py-2.5 rounded-xl font-bold font-body text-sm transition-colors whitespace-nowrap border border-white/15">
            Apenas essenciais
          </button>
          <button onClick={() => choose('all')} data-testid="accept-cookies"
            className="bg-[#00A8E8] hover:bg-[#0090c9] text-white px-6 py-2.5 rounded-xl font-bold font-body text-sm transition-colors whitespace-nowrap">
            Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyBanner;
